import { useEffect, useRef } from "react";

import { ActionIcon, Icon, TextInput, type TextInputProps } from "metabase/ui";

export function ListSearchField({
  autoFocus,
  onResetClick,
  ...props
}: TextInputProps & { onResetClick?: () => void }) {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    // this component is used within virtualized lists
    // rerendering an input with autoFocus causes the list to be scrolled to the top
    // so we override an autoFocus prop here to prevent any scrolling
    if (inputRef.current && autoFocus) {
      inputRef.current.focus({
        preventScroll: true,
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isRtl = document.documentElement.dir === "rtl";

  return (
    <TextInput
      dir={isRtl ? "rtl" : "ltr"}
      ref={inputRef}
      data-testid="list-search-field"
      leftSection={
        !isRtl && onResetClick && props.value ? (
          <ActionIcon onClick={onResetClick}>
            <Icon name="close" />
          </ActionIcon>
        ) : !isRtl && !props.value ? (
          <Icon name="search" />
        ) : null
      }
      rightSection={
        isRtl && onResetClick && props.value ? (
          <ActionIcon onClick={onResetClick}>
            <Icon name="close" />
          </ActionIcon>
        ) : isRtl && !props.value ? (
          <Icon name="search" />
        ) : null
      }
      leftSectionWidth={isRtl ? 40 : 36}
      rightSectionWidth={isRtl ? 36 : 40}
      styles={{
        input: {
          textAlign: isRtl ? "right" : "left",
        },
      }}
      {...props}
    />
  );
}
